import { useState, useEffect } from "react";
import "./SellerstepForm.css";
import "react-step-progress-bar/styles.css";
import { ProgressBar, Step } from "react-step-progress-bar";
import "react-datepicker/dist/react-datepicker.css";
import Stepone from "./Stepone/Stepone";
import Steptwo from "./Steptwo/Steptwo";
// import "react-circular-progressbar/dist/styles.css";
import Stepthree from "./Stepthree/Stepthree";
import Stepfour from "./Stepfour/Stepfour";
import Stepfive from "./Stepfive/Stepfive";
import Stepeight from "./Stepeight/Stepeight";
import Stepseven from "./Stepseven/Stepseven";
import Stepsix from "./Stepsix/Stepsix";
import Step_One_New from "./version_two_new_steps/step_one_new/Step_One_New";
import Step_Two_New from "./version_two_new_steps/step_two_new/Step_Two_New";
import Step_Three_New from "./version_two_new_steps/step_three_new/Step_Three_New";
import Step_Four_New from "./version_two_new_steps/step_four_new/Step_Four_New";

function SellerstepForm() {
  const [page, setPage] = useState(0);
  const [subPage, setSubPage] = useState(0); // State for sub-steps within Stepseven
  const [newUserContact, setNewUserContact] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [page, subPage]);

  const nextStep = () => {
    if (page === 6 && subPage === 0) {
      setPage((currPage) => currPage + 1);
      setSubPage(0);
    } else {
      setPage((currPage) => currPage + 1);
      setSubPage(0);
    }
  };

  const prevStep = () => {
    if (page === 6 && subPage === 1) {
      setSubPage(0);
    } else {
      setPage((currPage) => currPage - 1);
      setSubPage(0);
    }
  };

  // old steps

  // const PageDisplay = () => {
  //   switch (page) {
  //     case 0:
  //       return <Stepone nextStep={nextStep} heading={stepNames[0]} />;
  //     case 1:
  //       return <Steptwo nextStep={nextStep} prevStep={prevStep} />;
  //     case 2:
  //       return <Stepthree nextStep={nextStep} prevStep={prevStep} />;
  //     case 3:
  //       return (
  //         <Stepfour
  //           nextStep={nextStep}
  //           prevStep={prevStep}
  //           setNewUserContact={setNewUserContact}
  //           newUserContact={newUserContact}
  //         />
  //       );
  //     case 4:
  //       return <Stepfive nextStep={nextStep} prevStep={prevStep} />;
  //     case 5:
  //       return <Stepsix nextStep={nextStep} prevStep={prevStep} />;
  //     case 6:
  //       return (
  //         <Stepseven
  //           nextStep={nextStep}
  //           prevStep={prevStep}
  //           newUserContact={newUserContact}
  //         />
  //       );
  //     case 7:
  //       return <Stepeight nextStep={nextStep} prevStep={prevStep} />;
  //     default:
  //       return null;
  //   }
  // };

  // const stepNames = [
  //   "Business Details",
  //   "Certification & License",
  //   "Commission & Onboarding",
  //   "Owner Details",
  //   "GST/PAN Details",
  //   "Bank Details",
  //   "Verify Contact",
  //   "Onboarding Form",
  // ];

  const PageDisplay = () => {
    switch (page) {
      case 0:
        return (
          <Step_One_New
            nextStep={nextStep}
            prevStep={prevStep}
            setNewUserContact={setNewUserContact}
            newUserContact={newUserContact}
          />
        );
      case 1:
        return <Step_Two_New nextStep={nextStep} prevStep={prevStep} />;
      case 2:
        return <Step_Three_New nextStep={nextStep} prevStep={prevStep} />;
      case 3:
        return (
          <Step_Four_New
            nextStep={nextStep}
            prevStep={prevStep}
            setNewUserContact={setNewUserContact}
            newUserContact={newUserContact}
          />
        );
      default:
        return null;
    }
  };

  const stepNames = [
    "Business Details",
    "Certification & License",
    "Commission & Onboarding",
    "Owner Details",
  ];

  return (
    <>
      <section className="SellerStepMain"> 
        <div className="ProgressBar verticle_progress">
          <ProgressBar
            className=""
            percent={(page / (stepNames.length - 1)) * 100}
            filledBackground="#f57534"
            height="3px"
            style={{ margin: "auto" }}
          >
            {stepNames.map((name, index) => (
              <Step key={index}>
                {({ accomplished }) => (
                  <div
                    style={{
                      backgroundColor: index <= page ? "#f57534" : "#ffffff",
                      color: index <= page ? "#fff" : "#000000",
                      border:
                        index <= page
                          ? "2px solid #f57534 !important"
                          : "2px solid #f57534",
                      boxShadow:
                        index <= page ? "none" : "0px 0px 6px #00000029",
                    }}
                    className={`step ${index <= page ? "completed" : ""}`}
                  >
                    <p
                      className="mb-0"
                      style={{
                        color: index <= page ? "#fff" : "#f57534",
                        fontWeight: "600",
                      }}
                    >
                      {index + 1}
                    </p>
                    {/* <div className="step-name">{name}</div> */}
                  </div>
                )}
              </Step>
            ))}
          </ProgressBar>
        </div>

        <div className="userForm">
          <div className="step-Form-Container">{PageDisplay()}</div>
        </div>
      </section>
    </>
  );
}

export default SellerstepForm;
